import Lenis from 'lenis';

import { gsap } from 'gsap';
import { Draggable } from "gsap/Draggable";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger, Draggable)

class Scroller {
  constructor () {
    const lenis = new Lenis()
    window.lenis = lenis

    /* scrollTrigger */
    lenis.on('scroll', ScrollTrigger.update)
    gsap.ticker.add(time => {
      lenis.raf(time * 1000)
    })
    gsap.ticker.lagSmoothing(0)

    /* custom scrollbar */
    const thumb = document.querySelector('[data-scrollbar-thumb]')
    const thumbs = document.querySelectorAll('[data-scrollbar-thumb]')
    const thumbHeight = thumb.getBoundingClientRect().height

    lenis.on('scroll', ({ progress }) => {
      thumb.style.transform = `translate3d(0,${
        progress * (window.innerHeight - thumbHeight)
      }px,0)`
      ScrollTrigger.update()
    })

    const inner = document.querySelector('[data-scrollbar-inner]')
    const maxThumbScroll = inner.clientHeight - thumb.clientHeight

    Draggable.create(thumb, {
      type: 'y',
      bounds: inner,
      onDrag () {
        const progress = this.y / maxThumbScroll
        const newScroll = progress * lenis.limit
        lenis.scrollTo(newScroll, { immediate: true })
      }
    })

    lenis.on('scroll', ({ scroll, limit }) => {
      const progress = scroll / limit
      gsap.to(thumbs[0], { y: progress * maxThumbScroll, duration: 0 })
    })
  }
}

export default Scroller
